(function () {
  const selector = '[data-eg-pdp-reveal]:not([data-eg-pdp-reveal-bound="true"])';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;

  function reveal(section) {
    section.classList.add('is-visible');
    observer?.unobserve(section);
  }

  function getObserver() {
    if (observer) return observer;

    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) reveal(entry.target);
      });
    }, {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.12
    });

    return observer;
  }

  function init(root) {
    const scope = root instanceof Element ? root : document;
    const sections = scope.matches?.(selector) ? [scope] : Array.from(scope.querySelectorAll(selector));

    sections.forEach((section) => {
      section.dataset.egPdpRevealBound = 'true';

      if (reducedMotion.matches || !('IntersectionObserver' in window)) {
        reveal(section);
        return;
      }

      getObserver().observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
